$().ready(function() {
    $('.back-button').click(function(e) {
        e.preventDefault();

        let referrer = document.referrer;
        if (referrer && window.location.hostname === new URL(referrer).hostname) {
            window.location.href = referrer;
        } else {
            window.location.href = $(this).data('href');
        }
    });
});
